module.exports = __webpack_public_path__ + "img/Instagram.4a8c2347.png";